import ReferralInvitesList from './widgets/ReferralInvitesList';

interface TrackInvitesProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function TrackInvites({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: TrackInvitesProps) {
  return (
    <div className="overflow-y-auto overflow-x-hidden sm:w-[95%] md:w-full md:px-4 lg:w-[1148px] lg:max-w-[1148px] lg:px-0">
      <div className="flex h-full w-full flex-col py-[16px] pb-12">
        <ReferralInvitesList userType={userType} />
      </div>
    </div>
  );
}

export default TrackInvites;
